import { CUSTOM_STATUS_COLORS } from '@/common/item-statuses/item-statuses.constants.js';
import pick from 'lodash/pick';

export function injectColorsStatus (statuses, type = 'idea') {
    const updatedStatuses = statuses.map((status) => {
        const pickedStatus = pick(status, ['id', 'name', 'displayOrder', 'color', 'deletePending']);

        /* eslint-disable internal-rules/no-hardcoded-colors */
        const statusColorObj = status.color ? CUSTOM_STATUS_COLORS[status.color] : CUSTOM_STATUS_COLORS['#028CC2'];

        return {
            ...pickedStatus,
            type,
            style: statusColorObj,
        };
    });

    return updatedStatuses;
}
